import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import {
  DomSanitizer,
  Title,
  SafeResourceUrl,
} from '@angular/platform-browser';
import { AuctionService } from '../../../buyer-auctions/_services/auction/auction.service';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { BuyerAuthService } from 'src/app/app-modules/buyer/buyer-core/buyer-authentication/services/buyer-auth/buyer-auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  BehaviorSubject,
  Observable,
  Subscription,
  catchError,
  forkJoin,
  map,
  of,
  retry,
  switchMap,
} from 'rxjs';
import { PusherService } from 'src/app/Shared/services/pusher/pusher.service';
import { BuyerService } from 'src/app/app-modules/buyer/_services/buyer/buyer.service';
import { MatDialog } from '@angular/material/dialog';
import { BidIncrementsComponent } from 'src/app/app-modules/buyer/buyer-shared/components/bid-increments/bid-increments.component';
import { ConfirmDialogComponent } from 'src/app/Shared/components/confirm-dialog/confirm-dialog.component';
import { MapGeocoder } from '@angular/google-maps';
import { DecimalPipe, isPlatformBrowser, NgClass, CommonModule, ViewportScroller } from '@angular/common';

import { NotificationWindowService } from 'src/app/Shared/_services/notification/notification.service';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import {
  changeAuctionItemStatus,
  getEndingOfAuction,
  getEndingOfAuctionRealTimeCheck,
} from 'src/app/_utlis/auctions-helpers';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { ImageLightboxComponent } from '../../../../../../Shared/components/image-lightbox/image-lightbox.component';
import { MatIcon } from '@angular/material/icon';
import { HorseTopDetailsComponent } from '../../components/horse-top-details/horse-top-details.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { HorseViewDetailsDataComponent } from '../../../../../../Shared/components/horse-view-details-data/horse-view-details-data.component';
import { MapViewerComponent } from '../../../../../../Shared/components/map-viewer/map-viewer.component';
import { MatIconButton } from '@angular/material/button';
import { FileIframeComponent } from '../../../../../../Shared/components/file-iframe/file-iframe.component';
import { LockCategoryComponent } from '../../../../../../Shared/components/lock-category/lock-category.component';

import { BiddingServiceService } from 'src/app/app-modules/buyer/buyer-shared/services/bidding-service.service';
import { TimerComponent } from 'src/app/Shared/components/timer/timer.component';
import { IFile } from 'src/app/app-modules/seller/seller-modules/auctions/_interfaces/horse.interface';

import { format, addSeconds } from 'date-fns';
import { HttpService } from 'src/app/Core/interceptors/http/http.service';
import { TermsConditionsUpdatedPopupComponent } from 'src/app/app-modules/buyer/buyer-shared/components/terms-conditions-updated-popup/terms-conditions-updated-popup.component';
import { SafeUrlPipe } from 'src/app/Shared/_pipes/safe-url.pipe';
import { AutomaticBidComponent } from 'src/app/app-modules/buyer/buyer-shared/components/automatic-bid/automatic-bid.component';
import * as Events from 'src/app/_contstants/pusher-contstants';
import { PusherSubscriptionService } from 'src/app/app-modules/buyer/buyer-shared/services/pusher-subscription/pusher-subscription.service';
import { toZonedTime } from 'date-fns-tz';
import { CurrencyConversionsComponent } from '../../components/currency-conversions/currency-conversions.component';
import { HorseStatusDisplayService } from 'src/app/app-modules/buyer/buyer-shared/services/horse-status-display.service';
import { CustomCurrencyPipe } from 'src/app/Shared/_pipes/currency-pipe/custom-currency-pipe.pipe';
import { CurrencySymbolPipe } from 'src/app/Shared/_pipes/currency-symbol/currency-symbol.pipe';
import { BreadCrumbsComponent } from '../../../../../../Shared/components/bread-crumbs/bread-crumbs.component';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { HorseImagesGallaryComponent } from '../../components/horse-images-gallary/horse-images-gallary.component';
import { SkeletonLoaderComponent } from 'src/app/Shared/components/skeleton-loader/skeleton-loader.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { HorseNotesComponent } from '../../components/horse-notes/horse-notes.component';
import { no } from 'intl-tel-input/i18n';
import { LiveVideoService } from '../../_services/live-video/live-video.service';
import { LiveVideoPlayerComponent } from '../../components/live-video-player/live-video-player.component';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';
import { LanguageService } from 'src/app/Shared/services/language/language.service';
import { LocalizedNamePipe } from 'src/app/Shared/pipes/localized-name.pipe';
import {
  LotJumpComponent,
  LotJumpEntry,
} from 'src/app/Shared/components/lot-jump/lot-jump.component';
import {
  HORSE_FIELDS_SCHEMA,
  mapHorseDataToFields,
} from 'src/app/Shared/_models/horse-fields-schema';

@Component({
    selector: 'app-horse-view-page',
        standalone: true,
templateUrl: './horse-view-page-new.component.html',
    styleUrls: ['./horse-view-page-new.component.scss'],
    imports: [
    MatIcon,
    HorseTopDetailsComponent,
    ReactiveFormsModule,
    FormsModule,
    MatProgressSpinner,
    HorseViewDetailsDataComponent,
    MatIconButton,
    FileIframeComponent,
    LockCategoryComponent,
    TimerComponent,
    SafeUrlPipe,
    AutomaticBidComponent,
    NgClass,
    CommonModule,
    CurrencyConversionsComponent,
    CustomCurrencyPipe,
    CurrencySymbolPipe,
    BreadCrumbsComponent,
    HorseImagesGallaryComponent,
    SkeletonLoaderComponent,
    MatTooltipModule,
    HorseNotesComponent,
    LiveVideoPlayerComponent,
    TranslatePipe,
    LotJumpComponent
],
    providers: [CustomCurrencyPipe, CurrencySymbolPipe, LocalizedNamePipe]
})
export class HorseViewPageComponent implements OnDestroy {
  private onlineListener = this.handleOnline.bind(this);
  private visibilityListener = this.handleVisibilityChange.bind(this);

  markerOptions: google.maps.MarkerOptions = { draggable: false };
  activeImg: any;
  // progressWidth: any;

  horseId!: number;
  loggedIn!: boolean;
  isLoading!: boolean;
  horseDetails!: any;

  canBid: boolean = true;
  auc_type = '';
  amount!: string;
  amount_num!: number;
  favClicked = false;
  bidClicked = false;
  file: any;
  sub!: Subscription;
  channel: any;
  @ViewChild('amountEl') amountEl!: ElementRef;
  calledFirstTime!: boolean;
  tabsAvailable!: boolean;
  bidsIncrements!: { from: number; to: number; bid: number }[];
  currBidIn!: number;
  showNotMultiError!: boolean;
  catalogType!: string;
  nav: any;
  fields: any = {};
  schema: any[] = HORSE_FIELDS_SCHEMA;
  address!: string;
  auctionId!: string;
  auctionDetails: any;
  nextMinBid!: number;
  auctionTypePage: any;
  translation!: any;
  horseTranslation!: any;
  auctionMinBid: any;
  confirmationPopup!: any;
  currentDate: any;
  endAuctionDate: any;
  startAuctionDate: any;
  currentLang: any;
  slug = '';
  auctionSlug!: string;
  auctionSettings: any;
  userData: any;
  user_id!: number;
  albums: any[] = [];
  thumbnails: any[] = [];
  safeSrc!: SafeResourceUrl;
  isBrowser!: boolean;
  buyerTerms: any;

  isExpandedCurrency: boolean = false;
  currencyRates: any;
  currency: any;
  buyerStatus: any;
  sellerEmail: string = '';

  // Buyer status getters for template use
  get isBlocked(): boolean {
    return this.buyerStatus?.is_blocked === true;
  }

  get isSuspended(): boolean {
    return this.buyerStatus?.is_suspended === true;
  }

  get isBlockedOrSuspended(): boolean {
    return this.isBlocked || this.isSuspended;
  }

  private convertingValue = new BehaviorSubject<number>(0);
  convertingValue$ = this.convertingValue.asObservable();

  private isEndedAuction = new BehaviorSubject<boolean>(false);
  isEndedAuction$ = this.isEndedAuction.asObservable();

  private isAutoBid = new BehaviorSubject<boolean>(false);
  isAutoBid$ = this.isAutoBid.asObservable();

  breadcrumbItems: Breadcrumb[] = [
    { label: 'Home', url: '/', translationKey: 'buyer_catalogue.home' },
  ];
  selectedTab = 0;
  sellerData: any;
  heighestBidType: any;
  heighestBidderId: any;
  isUnderReserve: boolean = false;
  private lastHorseData: any;
  private staticHorseResponse: any = null;
  private staticHorseSlug = '';
  constructor(
    public sanitizer: DomSanitizer,
    private auctionService: AuctionService,
    private toastService: ToastService,
    private auth: BuyerAuthService,
    private router: Router,
    private route: ActivatedRoute,
    private pusherService: PusherService,
    private titleService: Title,
    private geocoder: MapGeocoder,
    private translate: TranslateService,
    private notification: NotificationWindowService,
    private biddingService: BiddingServiceService,
    private http: HttpService,
    private storage: StorageService,
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: any,
    private pusherSubscriptionService: PusherSubscriptionService,
    private viewportScroller: ViewportScroller,
    private liveVideoService: LiveVideoService,
    public localeService: LocaleService,
    private languageService: LanguageService,
    private localizedName: LocalizedNamePipe,
    private statusService: HorseStatusDisplayService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  /* --- Jump to a lot number ------------------------------------------- *
   * Previous / Next walks a catalogue one horse at a time. This takes a hip
   * number (CEO review, 18 Aug 2026).
   *
   * The native route is keyed by horse SLUG, not by number, so unlike the
   * International Auctions page this has to RESOLVE one to the other — which
   * is what the index is for.
   * --------------------------------------------------------------------- */

  /** `null` until first focus. Nothing is fetched before the box is used. */
  lotJumpEntries: LotJumpEntry[] | null = null;
  lotJumpLoading = false;
  /** Keyed so a jump into another auction re-asks rather than misresolving. */
  private lotJumpAuctionSlug = '';
  /**
   * hip number → horse slug. The box speaks in numbers and the route speaks in
   * slugs; this is the whole reason the native side needs an index at all.
   */
  private lotJumpSlugs = new Map<string, string>();

  myDialogRef!: DialogRef<unknown, any>;
  private lastDataFetchTime = 0;
  private readonly DATA_STALE_THRESHOLD = 30000;
  private subscriptions: Subscription[] = [];

  toggleCurrency() {
    this.isExpandedCurrency = !this.isExpandedCurrency;
  }

  onAutoBidChanged(value: boolean) {
    this.isAutoBid.next(value);
  }

  ngOnInit(): void {
    this.sub = this.auth.loggedIn_authorized$.subscribe((res) => {
      this.loggedIn = res;
      this.userData = this.storage.userData;

      if (this.calledFirstTime) {
        this.getData(false);
      }
      this.user_id = this.storage?.userData?.id;
      if (this.user_id && this.isBrowser) {
        this.subscribeToBuyerApplicationsChannels();
        this.subscribeToPrivateTermsAndConditionsUpdated();
        this.subscribeToAutomaticBiddingChannel();
        this.subscribeToOfferUpdatesChannel();
        this.subscribeToNotesDeletedChannel();
      } else {
        this.unsubscribeToPrivateUserChannel();
      }
    });
    this.route.params.subscribe((res) => {
      const nextSlug = res['slug'];
      if (this.slug !== nextSlug) {
        this.staticHorseResponse = null;
        this.staticHorseSlug = '';
      }

      this.slug = nextSlug;
      this.auctionSlug = res['auctionSlug'];
      this.getData();
    });
    this.route.queryParams.subscribe((res) => {
      // this.horseId = +res['id'];
      this.catalogType = res['type'];

      if (this.catalogType == 'sellers') {
        this.sellerData = {
          name: res['sellerName'] || 'Seller',
          id: res['sellerId'] || null,
        };
      }
    });
    if (this.isBrowser) {
      this.auctionTypePage = history.state.auctionTypePage;

      this.currentLang = JSON.parse(
        localStorage.getItem(this.storage.getPrefixedKey('selectedLang')) ??
          '{}'
      );
      this.subscribeToAuctionChannel();
      document.addEventListener('visibilitychange', this.visibilityListener);
      window.addEventListener('online', this.onlineListener);
    }

    // Subscribe to language changes to update breadcrumbs
    const langSub = this.translate.onLangChange.subscribe(() => {
      if (this.lastHorseData) {
        this.updateBreadcrumbs(this.lastHorseData);
      }
    });
    this.subscriptions.push(langSub);
  }

  private scrollToNotesSection(): void {
    if (!this.isBrowser) return;
    const notesElement = document.querySelector('app-horse-notes');

    if (notesElement) {
      notesElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }

  handleVisibilityChange() {
    if (document.visibilityState === 'visible') {
      const now = new Date().getTime();
      if (now - this.lastDataFetchTime > this.DATA_STALE_THRESHOLD) {
        this.getData(false);
        this.lastDataFetchTime = now;
      }
    }
  }
  handleOnline() {
    this.getData(false);
  }

  // Called when the internet connection is lost

  addViewCount() {
    this.toastService.clear();

    this.auctionService.addAuctionItemViewCount(this.horseId).subscribe(
      (res) => {},
      (err) => {
        this.toastService.showError(err.error.Error[0]);
      }
    );
  }

  private updateBreadcrumbs(data: any): void {
    // Reset breadcrumbs to start with Home
    this.breadcrumbItems = [
      {
        label: this.translate.instant('buyer_catalogue.home'),
        url: '/',
        translationKey: 'buyer_catalogue.home',
      },
    ];

    // Handle different catalog types
    switch (this.catalogType) {
      case 'catalogue':
        // Prepare query params for catalog navigation
        const catalogQueryParams = {
          auctionTypePage: this.auctionTypePage,
          // Add any other query params needed for proper catalog navigation
        };

        if (this.auctionTypePage === 'my_auctions') {
          // For my auctions case, add My Account before My Auctions
          this.breadcrumbItems.push({
            label:
              this.translate.instant('buyer_header.my_account') || 'My Account',
            url: '/buyer/account',
            translationKey: 'buyer_header.my_account',
          });

          // Then add My Auctions with query params
          this.breadcrumbItems.push({
            label: this.translate.instant('buyer_catalogue.my_auctions'),
            url: '/buyer/account/my-auctions',
            queryParams: catalogQueryParams,
            translationKey: 'buyer_catalogue.my_auctions',
          });
        } else {
          // Normal auctions case (not my auctions)
          this.breadcrumbItems.push({
            label: this.translate.instant('buyer_catalogue.auctions'),
            url: '/buyer/auctions/list/all',
            queryParams: catalogQueryParams,

            translationKey: 'buyer_catalogue.auctions',
          });
        }

        // Add auction name breadcrumb with query params (dynamic - no translation key)
        this.breadcrumbItems.push({
          label: `${this.localizedName.transform(
            data?.auction.name
          )} ${this.translate.instant('buyer_catalogue.catalogue')}`,
          url: `/buyer/auctions/${this.auctionSlug}`,
          queryParams: catalogQueryParams,
          translationKey: '',
        });

        // Add horse name breadcrumb (dynamic - no translation key)
        this.breadcrumbItems.push({
          label: data.name,
          url: '',
          translationKey: '',
        });
        break;

      case 'my-bids':
        this.breadcrumbItems.push({
          label: this.translate.instant('buyer_header.my_account'),
          url: '/buyer/account',
          translationKey: 'buyer_header.my_account',
        });
        this.breadcrumbItems.push({
          label: this.translate.instant('buyer_bids.buyer_my_bids'),
          url: '/buyer/account/my-bids',
          translationKey: 'buyer_bids.buyer_my_bids',
        });
        this.breadcrumbItems.push({
          label: data.name,
          url: '',
          translationKey: '',
        });
        break;

      case 'wishlist':
        this.breadcrumbItems.push({
          label: this.translate.instant('buyer_header.my_account'),
          url: '/buyer/account',
          translationKey: 'buyer_header.my_account',
        });
        this.breadcrumbItems.push({
          label: this.translate.instant('buyer_header.short_list'),
          url: '/buyer/account/wishlist',
          translationKey: 'buyer_header.short_list',
        });
        this.breadcrumbItems.push({
          label: data.name,
          url: '',
          translationKey: '',
        });
        break;

      case 'my-horses':
        this.breadcrumbItems.push({
          label: this.translate.instant('buyer_header.my_account'),
          url: '/buyer/account',
          translationKey: 'buyer_header.my_account',
        });
        this.breadcrumbItems.push({
          label: this.translate.instant('buyer_my_horses.buyer_my_horses'),
          url: '/buyer/account/my-horses',
          translationKey: 'buyer_my_horses.buyer_my_horses',
        });
        this.breadcrumbItems.push({
          label: data.name,
          url: '',
          translationKey: '',
        });
        break;
      case 'notes':
        this.breadcrumbItems.push({
          label: this.translate.instant('buyer_header.my_account'),
          url: '/buyer/account',
          translationKey: 'buyer_header.my_account',
        });
        this.breadcrumbItems.push({
          label: this.translate.instant('horse_info.horse_note'),
          url: '/buyer/account/horses-notes',
          translationKey: 'horse_info.horse_note',
        });
        this.breadcrumbItems.push({
          label: data.name,
          url: '',
          translationKey: '',
        });
        break;

      case 'live-horses':
        this.breadcrumbItems.push({
          label: this.translate.instant('buyer_header.live_horses'),
          url: '/',
          translationKey: 'buyer_header.live_horses',
        });
        this.breadcrumbItems.push({
          label: data.name,
          url: '',
          translationKey: '',
        });
        break;

      case 'sellers':
        this.breadcrumbItems.push({
          label: this.translate.instant('buyer_header.nav_sellers'),
          url: '/buyer/sellers/list',
          translationKey: 'buyer_header.nav_sellers',
        });
        if (this.sellerData) {
          this.breadcrumbItems.push({
            label: this.sellerData.name || 'Seller',
            url: `/buyer/sellers/seller-details/${this.sellerData.id}`,
            translationKey: '',
          });
        }
        this.breadcrumbItems.push({
          label: data.name,
          url: '',
          translationKey: '',
        });
        break;

      default:
        // Default case if none of the above match
        this.breadcrumbItems.push({
          label: data.name,
          url: '',
          translationKey: '',
        });
        break;
    }
  }

  getData(reload = true, clearToast = true): void {
    let serverTime = 0;
    const interval = setInterval(() => {
      serverTime++;
    }, 1000);
    if (clearToast) {
      this.toastService.clear();
    }
    if (reload) {
      this.isLoading = true;
    }

    this.albums = [];
    this.thumbnails = [];

    const bidsRequest = reload
      ? this.auctionService.bidsIncrementation()
      : of(null);
    const shouldFetchStatic =
      !this.staticHorseResponse || this.staticHorseSlug !== this.slug;
    const horseRequest = shouldFetchStatic
      ? this.auctionService.getHorseBySlug(this.slug).pipe(
          map((horseResponse) => {
            this.staticHorseResponse = horseResponse;
            this.staticHorseSlug = this.slug;
            return horseResponse;
          })
        )
      : of(this.staticHorseResponse);

    forkJoin([horseRequest, bidsRequest])
      .pipe(
        switchMap(([horseResponse, bidsResponse]) => {
          const auctionItem = horseResponse?.data?.auction_item;
          if (!auctionItem?.id || !auctionItem?.auction_id) {
            return of({ horseResponse, bidsResponse, dynamicResponse: null });
          }

          return this.auctionService
            .getAuctionItemsSettings({
              auction_item_ids: [auctionItem.id],
              auction_ids: [auctionItem.auction_id],
              include_profile_fields: true,
            })
            .pipe(
              // Transient failures (e.g. 429 rate-limiting) would otherwise drop status/price
              // and make a closed horse look open. Retry before falling back; the static
              // getBySlug response now also carries status as a safety net (see backend).
              retry({ count: 2, delay: 800 }),
              map((dynamicResponse) => ({ horseResponse, bidsResponse, dynamicResponse })),
              catchError(() => of({ horseResponse, bidsResponse, dynamicResponse: null }))
            );
        })
      )
      .subscribe({
      next: (response) => {
        if (reload) {
          this.bidsIncrements = response.bidsResponse?.data;
        }

        const mergedAuctionItem = this.mergeDynamicAuctionItem(
          response.horseResponse?.data?.auction_item,
          response.dynamicResponse?.data
        );

        if (!mergedAuctionItem) {
          clearInterval(interval);
          this.isLoading = false;
          this.toastService.showError('Auction item data is missing');
          return;
        }

        this.processHorseData(mergedAuctionItem);
        this.processAuctionData(
          mergedAuctionItem,
          serverTime,
          response.horseResponse?.current_datetime
        );
        this.processTermsData({
          buyer_accepted:
            mergedAuctionItem?.buyer_accepted_seller_terms ??
            response.horseResponse?.data?.buyer_accepted_seller_terms,
          seller_terms: response.horseResponse?.data?.seller_terms,
        });

        // Add the missing live video check
        this.checkAndSetLiveVideo(response.horseResponse);

        clearInterval(interval);

        if (!this.calledFirstTime && this.isBrowser) {
          this.addViewCount();
          this.subscribeToAuctionItemUpdated();
          this.calledFirstTime = true;
        }

        this.isLoading = false;
        if (this.catalogType === 'notes') {
          setTimeout(() => {
            this.scrollToNotesSection();
          }, 300);
        }
      },

      error: (error) => {
        clearInterval(interval);
        this.isLoading = false;
        this.toastService.showError(
          error?.error?.Error?.[0] || 'An error occurred'
        );
      },
    });
  }

  private mergeDynamicAuctionItem(baseAuctionItem: any, dynamicData: any): any {
    if (!baseAuctionItem) {
      return baseAuctionItem;
    }

    const itemKey = String(baseAuctionItem.id);
    const auctionKey = String(baseAuctionItem.auction_id);

    const dynamicItem =
      dynamicData?.auction_items?.[itemKey] ??
      dynamicData?.auction_items?.[baseAuctionItem.id];

    const dynamicAuctionSettings =
      dynamicData?.auctions?.[auctionKey] ??
      dynamicData?.auctions?.[baseAuctionItem.auction_id];

    if (!dynamicItem && !dynamicAuctionSettings) {
      return baseAuctionItem;
    }

    return {
      ...baseAuctionItem,
      auction_settings:
        dynamicItem?.auction_settings ??
        dynamicAuctionSettings ??
        baseAuctionItem.auction_settings,
      auction_item_settings:
        dynamicItem?.auction_item_settings ?? baseAuctionItem.auction_item_settings,
      highest_bid: dynamicItem?.highest_bid ?? baseAuctionItem.highest_bid,
      make_an_offer: dynamicItem?.make_an_offer ?? baseAuctionItem.make_an_offer,
      status: dynamicItem?.status ?? baseAuctionItem.status,
      display_price: dynamicItem?.display_price ?? baseAuctionItem.display_price,
      buyer_name: dynamicItem?.buyer_name ?? baseAuctionItem.buyer_name,
      is_under_reserve:
        dynamicItem?.is_under_reserve ?? baseAuctionItem.is_under_reserve,
      bids_count: dynamicItem?.bids_count ?? baseAuctionItem.bids_count,
      bidders_count: dynamicItem?.bidders_count ?? baseAuctionItem.bidders_count,
      status_override: dynamicItem?.status_override ?? baseAuctionItem.status_override,
      buyer_name_override:
        dynamicItem?.buyer_name_override ?? baseAuctionItem.buyer_name_override,
      price_override: dynamicItem?.price_override ?? baseAuctionItem.price_override,
      winner: dynamicItem?.winner ?? baseAuctionItem.winner,
      auction_item_winner_id:
        dynamicItem?.auction_item_winner_id ?? baseAuctionItem.auction_item_winner_id,
      unsold_flag_at: dynamicItem?.unsold_flag_at ?? baseAuctionItem.unsold_flag_at,
      offer_window_ended_at:
        dynamicItem?.offer_window_ended_at ?? baseAuctionItem.offer_window_ended_at,
      buyer_status: dynamicItem?.buyer_status ?? baseAuctionItem.buyer_status,
      buyer_accepted_seller_terms:
        dynamicItem?.buyer_accepted_seller_terms ??
        baseAuctionItem.buyer_accepted_seller_terms,
      rna_status: dynamicItem?.rna_status ?? baseAuctionItem.rna_status,
      expired: dynamicItem?.expired ?? baseAuctionItem.expired,
      automatic_bidding:
        dynamicItem?.automatic_bidding ?? baseAuctionItem.automatic_bidding,
      offers: dynamicItem?.offers ?? baseAuctionItem.offers,
      has_update: dynamicItem?.has_update ?? baseAuctionItem.has_update,
      update_content:
        dynamicItem?.update_content ?? baseAuctionItem.update_content,
      buyer_horse_note:
        dynamicItem?.buyer_horse_note ?? baseAuctionItem.buyer_horse_note,
      auction_files: dynamicItem?.auction_files ?? baseAuctionItem.auction_files,
    };
  }

  private checkAndSetLiveVideo(horseData: any) {
    if (horseData?.data?.auction_item?.auction?.livestream?.ivs_playback_url) {
      this.liveVideoService.setLiveVideo({
        ivs_playback_url:
          horseData.data.auction_item.auction.livestream.ivs_playback_url,
        auction_name: horseData.data.auction_item.auction.name,
        auction_id: horseData.data.auction_item.auction.id,
      });
    }
  }

  private processTermsData(data: any) {
    this.buyerTerms = data;
  }
  private processHorseData(data: any): void {
    if (!data) {
      return;
    }

    const {
      id,
      name,
      auction_pictures,
      auction_files = {},
      min_bid,
      winner_user_id,
      highest_bid,
      created_by_user_name,
      nav,
      hip_number,
      bidders_count,
      bids_count,
      buyer_document_categories,
      videos,
      rna_status = false,
      reserve_price,
      winner,
      expired = false,
      automatic_bidding = null,
      currency_rates,
      offers = [],
      make_an_offer = {},
      unsold_flag_at,
      withdrawn_at,
      status,
      has_update = false,
      update_content = null,
      buyer_horse_note = null,
      horse,
      display_price,
      buyer_name,
      is_under_reserve,
    } = data;
    const makeOfferWindowDays = Number(make_an_offer?.time_window_days ?? 0);

    this.isUnderReserve = is_under_reserve || false;
    this.currencyRates = currency_rates;
    this.lastHorseData = data;
    this.updateBreadcrumbs(data);
    this.horseId = id;
    this.nav = nav;
    this.auctionId = data.auction_id;
    this.auctionDetails = data.auction;

    const filesArr = this.processAuctionFiles(auction_files, videos);

    // Map horse data to match schema field names using the helper function
    this.fields = mapHorseDataToFields(data.horse);

    if (this.fields['Location']) {
      this.getAddress({
        lat: this.fields['Location'].latitude,
        lng: this.fields['Location'].longitude,
      });
    }

    // Schema is imported from horse-fields-schema.ts
    this.tabsAvailable = filesArr.some((el: any) => el.files?.length >= 1);

    const {
      can_bid = false,
      updated_end_date_time,
      in_user_wishlist = false,
      highest_bid_amount = 0,
    } = data.auction_item_settings || {};

    this.auctionMinBid = data.auction.min_bid;
    this.canBid = can_bid;

    this.horseDetails = {
      can_bid,
      id,
      winner_user_id,
      name,
      highest_bid_amount: highest_bid_amount || 0,
      files: filesArr,
      auction_pictures,
      videos,
      min_bid,
      in_user_wishlist,
      auc_id: data.auction.id,
      highest_bid,
      created_by_user_name,
      nav,
      hip_number,
      bidders_count,
      bids_count,
      buyer_document_categories,
      rna_status,
      reserve_price,
      winner,
      expired,
      automatic_bidding,
      offers,
      make_an_offer,
      unsold_flag_at,
      buyer_horse_note,
      rna_status_offers:
        rna_status &&
        !make_an_offer?.item_has_accepted_offer &&
        makeOfferWindowDays !== 0,
      unSold_offers:
        this.statusService.isNotSold({ status }) &&
        !make_an_offer?.item_has_accepted_offer &&
        makeOfferWindowDays !== 0,
      withdrawn_at,
      notAuthBidBoard: !this.loggedIn && withdrawn_at == null ? true : false,
      has_update,
      update_content,
      status,
      horse,
      display_price,
      buyer_name,
    };

    const isAutoBid = automatic_bidding !== null ? true : false;
    this.isAutoBid.next(isAutoBid);

    if (highest_bid_amount) {
      this.amount_num = highest_bid_amount;
      this.amount = this.convertToStringWithComma(String(highest_bid_amount));
    } else {
      this.amount_num =
        min_bid < this.bidsIncrements[0]?.bid
          ? this.bidsIncrements[0]?.bid
          : min_bid || 0;
      this.amount = this.convertToStringWithComma(
        String(
          min_bid < this.bidsIncrements[0]?.bid
            ? this.bidsIncrements[0]?.bid
            : min_bid || 0
        )
      );
    }

    this.horseDetails = {
      ...this.horseDetails,
      auction_min_bid: this.auctionMinBid,
    };

    // this.convertingValue.next(convertedValue);

    this.getBidInc();
    this.setNextMinBid();

    this.processMediaFiles(auction_pictures, videos);
  }

  private getActiveAuctionValue(): number {
    const { highest_bid_amount, auction_min_bid, min_bid } = this.horseDetails;

    if (Number(highest_bid_amount) > 0) {
      return highest_bid_amount;
    }

    if (Number(auction_min_bid) > 0) {
      return auction_min_bid;
    }

    return min_bid ?? 0;
  }

  private getPreviousAuctionValue(): number {
    const { rna_status, winner, highest_bid_amount, reserve_price } =
      this.horseDetails;

    // Sold case: has winner and not RNA
    if (!rna_status && winner) {
      return winner.price;
    }

    // Highest bid case: not RNA but no winner
    if (!rna_status && !winner) {
      return Number(highest_bid_amount);
    }

    // RNA case
    return rna_status ? Number(reserve_price) : 0; // Return reserve_price if RNA, 0 otherwise
  }
  private intervalId!: number;

  private processAuctionData(
    data: any,
    serverTime: number,
    currentDateTime: any
  ): void {
    this.heighestBidType = data.highest_bid?.bid_by_type;
    this.heighestBidderId = data.highest_bid?.bid_by_id;
    this.auctionSlug = data.auction.slug;
    this.startAuctionDate = data.auction.auction_start_date;
    this.endAuctionDate = data.extended_end_date;
    const fallbackAuctionSettings = this.getFallbackAuctionSettings(data, currentDateTime);
    this.auctionSettings = data.auction_settings || fallbackAuctionSettings;
    this.currency = data?.auction?.currency;
    this.buyerStatus = data?.buyer_status;
    this.sellerEmail = data?.seller_email || data?.ownerUser?.email || '';
    const { running, ended } = this.auctionSettings;
    this.getAuctionType(running, ended);
    this.currentDate = format(
      addSeconds(currentDateTime, serverTime),
      'yyyy-MM-dd HH:mm:ss'
    );

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.auc_type == 'active') {
      const convertedValue = this.getActiveAuctionValue();
      this.convertingValue.next(convertedValue);
      this.intervalId = getEndingOfAuctionRealTimeCheck(
        data?.auction?.auction_end_date,
        currentDateTime,
        (ended: boolean) => {
          if (ended) {
            clearInterval(this.intervalId); // Stop the interval once the auction has ended

            if (!this.isEndedAuction.value) {
              this.isEndedAuction.next(true);
              const isAutoBid = false;
              this.isAutoBid.next(isAutoBid);
            }
          } else {
            this.isEndedAuction.next(false);
          }
        }
      );
    }
    if (this.auc_type === 'previous') {
      const convertedValue = this.getPreviousAuctionValue();
      this.convertingValue.next(convertedValue);
    }
  }

  private getFallbackAuctionSettings(data: any, currentDateTime: any): any {
    const now = new Date(currentDateTime || new Date());
    const start = new Date(data?.auction?.auction_start_date);
    const end = new Date(
      data?.auction?.extended_end_date ||
        data?.extended_end_date ||
        data?.auction?.auction_end_date
    );

    const running = now >= start && now < end;
    const ended = now >= end;

    return {
      running,
      ended,
    };
  }

  private processAuctionFiles(auction_files: any, videos: any): any[] {
    const filesArr = Object.keys(auction_files).reduce(
      (accumulator: any, key: any) => {
        const files = auction_files[key].files.map(
          (file: { id: number; url: string }) => ({
            id: file.id,
            file_url: file.url,
            file_name: file.url.split('/').reverse()[0],
            file: file.url,
          })
        );
        const currentObject = { ...auction_files[key], files };
        accumulator.push(currentObject);
        return accumulator;
      },
      []
    );

    let videosCategoryIndex = filesArr.findIndex(
      (category: any) => category.name === 'videos'
    );

    if (videosCategoryIndex === -1) {
      if (videos?.length > 0) {
        filesArr.push({
          name: this.translate.instant('horse_view.videos'),
          can_upload: null,
          lock_action_needed: null,
          lock_type: null,
          files:
            videos.map((video: any) => ({
              file_url: video?.embed_video_url,
              file_name: video?.embed_video_url.split('/').reverse()[0],
              file: video?.embed_video_url,
            })) || [],
        });
      }
    } else {
      filesArr[videosCategoryIndex].files = [
        ...filesArr[videosCategoryIndex].files,
        ...(videos.map((video: any) => ({
          file_url: video?.embed_video_url,
          file_name: video?.embed_video_url.split('/').reverse()[0],
          file: video?.embed_video_url,
        })) || []),
      ];
    }

    return filesArr;
  }

  // Dark gray placeholder for videos without thumbnails
  private readonly VIDEO_PLACEHOLDER =
    'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect fill="%231a1a1a" width="400" height="300"/%3E%3C/svg%3E';

  private processMediaFiles(auction_pictures: any, videos: any): void {
    if (auction_pictures) {
      auction_pictures.forEach((img: IFile) => {
        const album: any = {
          src: img.url,
          type: 'image',
          thumb: img.url || '/assets/images/defualt-image.jpg',
        };
        this.albums.push(album);
      });
    }

    if (videos) {
      videos.forEach(
        (video: { embed_video_url: string; thumbnail: string }) => {
          // const src = url.replace('watch?v=', 'embed/');
          const album: any = {
            thumb: video?.thumbnail || this.VIDEO_PLACEHOLDER,
            src: video?.embed_video_url,
            type: 'video',
          };
          this.albums.push(album);
        }
      );
    }
    this.thumbnails = [...this.albums];
    // this.thumbnails= this.albums.map((item: any) => ({
    //   ...item,
    //   thumb:
    //     item.type === 'video'
    //       ? item?.thumbnail
    //       : item.src,
    // }));
    this.activeImg = this.thumbnails.length && this.thumbnails[0];
  }

  private setNextMinBid(): void {
    if (
      this.horseDetails &&
      this.horseDetails.highest_bid_amount === 0 &&
      (this.horseDetails.min_bid || this.horseDetails.auction_min_bid)
    ) {
      const min =
        this.horseDetails.min_bid || this.horseDetails.auction_min_bid;
      this.nextMinBid = Number(
        min < this.bidsIncrements[0]?.bid ? this.bidsIncrements[0]?.bid : min
      );
      this.amount = this.convertToStringWithComma(String(this.nextMinBid));
      this.amount_num = this.convertAmountToNumber(this.amount);

      this.horseDetails = {
        ...this.horseDetails,
        nextMinBid: this.nextMinBid,
      };
    } else {
      this.getNexMinimumBid();
    }
  }

  getNexMinimumBid() {
    this.nextMinBid = this.biddingService.getNextMinimumBid(
      this.horseDetails,
      this.bidsIncrements
    );
    this.amount = this.convertToStringWithComma(String(this.nextMinBid));
    this.amount_num = this.convertAmountToNumber(this.amount);
    this.horseDetails = { ...this.horseDetails, nextMinBid: this.nextMinBid };
  }
  getBidInc() {
    this.currBidIn = this.biddingService.getBidIncrement(
      this.amount_num,
      this.bidsIncrements
    );
  }

  getAuctionType(running: boolean, ended: boolean) {
    // this.horseDetails.auc_running = running;
    // this.horseDetails.auc_ended = ended;

    if (running && !ended) {
      //active
      this.auc_type = 'active';

      // Check if individual horse has closed (has any status)
      // This handles cases where the horse's individual extended_end_date has passed
      // while the overall auction is still running
      if (this.horseDetails?.status) {
        this.canBid = false;
        this.auc_type = 'previous';
      } else if (this.horseDetails?.winner?.buyer_user_id) {
        // Legacy check for winner (kept for backward compatibility)
        this.canBid = false;
        this.auc_type = 'previous';
      }
    } else if (ended && !running) {
      //prev
      this.auc_type = 'previous';
    } else if (!running && !ended) {
      //upcoming
      this.auc_type = 'upcoming';
    }
  }

  openInNewTap(file: string) {
    if (this.isBrowser) {
      window.open(file, '_blank');
    }
  }
  // setActiveImg(img: string, index: number) {
  //   console.log('set', img, index);
  //   // this.activeImg = img;
  //   // this.activeImgIndx = index;

  //   this.openLightbox(index);
  // }

  increaseBy(num: number) {
    // this.getBidInc()

    if (num == 1) {
      this.amount_num += this.currBidIn;
    } else {
      this.amount_num -= this.currBidIn;
    }
    this.getBidInc();

    this.amount = this.convertToStringWithComma(String(this.amount_num));
    this.onAmountChange(this.amount);
  }

  convertAmountToNumber(num: string) {
    return this.biddingService.convertAmountToNumber(num);
  }

  onAmountChange(amount: string) {
    this.amount = this.convertToStringWithComma(amount);
    this.amount_num = this.convertAmountToNumber(this.amount);
    this.amountEl.nativeElement.value = this.convertToStringWithComma(amount);
    if (amount.trim() === '') {
      this.getBidInc();
    }
    if (!this.isIncremental(this.amount_num, this.currBidIn)) {
      this.showNotMultiError = true;
    } else {
      this.showNotMultiError = false;
    }
  }
  isIncremental(number: number, incrementVal: number) {
    return number >= this.nextMinBid;
  }

  // isMultiple(number: number, multiple: number) {
  //   return number % multiple === 0;
  // }
  openAcceptTermsConditions(): void {
    const dialogRef = this.dialog.open(TermsConditionsUpdatedPopupComponent, {
      width: '520px',
      panelClass: ['buyer-theme'],
      direction: this.localeService.dir,
      data: { ...this.buyerTerms, auction_id: this.auctionId },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.data?.accepted == 1) {
        this.getData();
      }
    });
  }

  bid() {
    this.toastService.clear();
    if (
      this.buyerTerms?.seller_terms !== null &&
      this?.buyerTerms?.buyer_accepted !== 'accepted'
    ) {
      this.openAcceptTermsConditions();
    } else if (!this.showNotMultiError) {
      const title = this.translate.instant('bid_now_popup.confirm_bid');
      const message = this.translate.instant('bid_now_popup.confirmation_msg');
      const bid_amount = this.convertAmountToNumber(this.amount);

      this.confirmationPopup = this.dialog.open(ConfirmDialogComponent, {
        width: '400px',
        panelClass: ['buyer-theme'],

        direction: this.localeService.dir,

        data: { title, message, bid_amount },
      });
      const modal = this.confirmationPopup.componentInstance;

      modal.confirm.subscribe((confirm: boolean) => {
        if (confirm) {
          modal.isLoading = true;
          this.bidClicked = true;
          this.auctionService
            .bid({
              auction_item_id: this.horseDetails?.id,
              amount: bid_amount,
            })
            .subscribe({
              next: (res: any) => {
                this.horseDetails.highest_bid_amount = this.amount_num;
                this.horseDetails.bids_count = (this.horseDetails.bids_count || 0) + 1;
                this.heighestBidType = 'user';
                this.heighestBidderId = this.userData?.id;
                this.isUnderReserve = res?.is_under_reserve || false;
                this.getBidInc();
                this.getNexMinimumBid();
                this.bidClicked = false;
                this.confirmationPopup.close();
                this.convertingValue.next(this.amount_num);
              },
              error: (err) => {
                modal.isLoading = false;
                this.bidClicked = false;
                this.confirmationPopup.close();

                if (err.error?.extra_data?.current_bid) {
                  const { bidders_count, bids_count, highest_bid } =
                    err.error?.extra_data;
                  this.horseDetails.bidders_count = bidders_count;
                  this.horseDetails.bids_count = bids_count;
                  this.amount = this.convertToStringWithComma(
                    String(highest_bid?.amount)
                  );
                  this.heighestBidType = highest_bid?.bid_by_type;
                  this.heighestBidderId = highest_bid?.bid_by_id;

                  this.amount_num = this.horseDetails.highest_bid_amount =
                    highest_bid?.amount;
                  // this.horseDetails.highest_bid;

                  this.getBidInc();
                  this.getNexMinimumBid();
                }
              },
            });
        }
      });
    }
  }

  /**
   * First focus on the jump box: fetch the auction's lot index, once.
   *
   * Withdrawn lots arrive FLAGGED rather than omitted, and the box blocks them
   * with a message. They are in the printed catalogue, so a visitor will type
   * them; being told "lot 1 has been withdrawn" is the answer they came for,
   * and it beats both a silent failure and a page that opens on a horse nobody
   * can bid on. Unpublished lots are not in the index at all — the API does not
   * disclose them — so they answer with the not-found message instead.
   */
  onLotJumpLoad(): void {
    if (!this.auctionSlug || this.lotJumpLoading) {
      return;
    }
    if (this.lotJumpEntries !== null && this.lotJumpAuctionSlug === this.auctionSlug) {
      return;
    }

    const slug = this.auctionSlug;
    this.lotJumpLoading = true;

    this.subscriptions.push(
      this.auctionService.getAuctionLotIndex(slug).subscribe({
        next: (res: any) => {
          const lots = res?.data?.lots ?? [];

          this.lotJumpSlugs = new Map(
            lots.map((lot: any) => [String(lot.hip_number), String(lot.slug)])
          );

          this.lotJumpEntries = lots.map((lot: any) => ({
            value: String(lot.hip_number),
            label: lot.name ?? '',
            blocked: !!lot.withdrawn,
            tagKey: lot.withdrawn ? 'lot_jump.tag_withdrawn' : undefined,
          }));

          this.lotJumpAuctionSlug = slug;
          this.lotJumpLoading = false;
        },
        error: () => {
          // A private auction the visitor cannot enter answers with an access
          // error, exactly as the catalogue does. `[]` hides the box rather
          // than leaving a control that can only fail.
          this.lotJumpSlugs = new Map();
          this.lotJumpEntries = [];
          this.lotJumpAuctionSlug = slug;
          this.lotJumpLoading = false;
        },
      })
    );
  }

  /**
   * A resolved hip number. The same navigation `nextEntry()` makes — including
   * `type`, without which the catalogue context is lost on arrival.
   */
  onLotJump(entry: LotJumpEntry): void {
    const horseSlug = this.lotJumpSlugs.get(entry.value);

    if (!horseSlug) {
      return;
    }

    this.calledFirstTime = false;
    this.router.navigate(['/buyer/auctions', this.auctionSlug, 'horse', horseSlug], {
      queryParams: {
        type: this.catalogType,
      },
    });
  }

  //slug
  nextEntry() {
    const { auction_slug, slug, id } = this.horseDetails?.nav?.next;
    if (id) {
      this.calledFirstTime = false;
      this.router.navigate(
        ['/buyer/auctions', auction_slug, 'horse', slug],

        {
          queryParams: {
            type: this.catalogType,
          },
        }
      );
    }
  }
  //slug

  prevEntry() {
    const { auction_slug, slug, id } = this.horseDetails?.nav?.previous;
    if (id) {
      this.calledFirstTime = false;

      this.router.navigate(
        ['/buyer/auctions', auction_slug, 'horse', slug],

        {
          queryParams: {
            type: this.catalogType,
          },
        }
      );
    }
  }

  convertToStringWithComma(num: string) {
    return this.biddingService.convertToStringWithComma(num);
  }

  openBidIncrememts() {
    this.dialog.open(BidIncrementsComponent, {
      // width: '400px',
      direction: this.localeService.dir,
      panelClass: ['buyer-theme'],

      data: { bidsIncrements: this.bidsIncrements },
    });
  }
  getAddress(latLng: google.maps.LatLngLiteral) {
    if (this.isBrowser) {
      this.geocoder.geocode({ location: latLng }).subscribe(({ results }) => {
        this.address = results[0]?.formatted_address;
      });
    }
  }

  next() {
    this.thumbnails.push(this.thumbnails.shift());
  }
  previous() {
    this.thumbnails.unshift(this.thumbnails.pop());
  }
  get isBidDisabled(): boolean {
    return this.biddingService.isBidDisabled(
      this.userData?.id,
      this.horseDetails,
      this.amount_num,
      this.nextMinBid,
      this.auctionMinBid,
      this.bidClicked,
      this.heighestBidType,
      this.heighestBidderId
    );
  }

  //////////////////PUSHER SUBSCRIPTIONS/////////////////////
  buyerApplicationsEvents: any[] = [
    {
      events: [
        {
          eventName: Events.BUYER_APP_ACCEPTED,
          showNot: true,
          pushTitle: 'Status Update',
          accepted: true,
        },

        {
          eventName: Events.BUYER_APP_REJECTED,
          showNot: true,
          pushTitle: 'Status Update',
          accepted: false,
        },
      ],
    },
  ];
  subscribeToAuctionItemUpdated() {
    const subscription = this.pusherSubscriptionService
      .getAuctionItemUpdates$()
      .subscribe((data) => {
        this.handleAuctionItemUpdate(data);
      });

    this.subscriptions.push(subscription);
  }
  subscribeToAuctionItemUpdatesUpdated() {
    const subscription = this.pusherSubscriptionService
      .getHorseUpdates$()
      .subscribe((data) => {
        if (data.auction_item_id === this.horseId) {
          this.getData(false);
        }
      });

    this.subscriptions.push(subscription);
  }
  handleAuctionItemUpdate(data: any) {
    if (data.auction_item_id === this.horseId) {
      this.horseDetails.bidders_count = data?.bids?.bidders_count;
      this.horseDetails.bids_count = data?.bids?.bids_count;
      // Handle legacy status object format
      this.horseDetails.rna_status = data?.status_legacy?.rna_status || data?.status?.rna_status || false;
      // Update under reserve indicator
      this.isUnderReserve = data?.is_under_reserve || false;
      this.amount = this.convertToStringWithComma(
        String(data?.bids?.highest_bid)
      );
      this.heighestBidType = data?.bids?.last_bid_by_type;
      this.heighestBidderId = data?.bids?.last_bid_by_id;

      this.amount_num = this.horseDetails.highest_bid_amount =
        data?.bids?.highest_bid;
      this.convertingValue.next(this.horseDetails.highest_bid_amount);

      this.getBidInc();
      this.getNexMinimumBid();

      this.horseDetails.winner = data?.winner;
      this.horseDetails.expired = data?.status_legacy?.expired || data?.status?.expired;

      // Update individual horse status from Pusher event
      // This is the unified status field (sold, rna, not_sold, ps, winner, withdrawn)
      if (data?.status && typeof data.status === 'string') {
        this.horseDetails.status = data.status;
        // Also update display_price and buyer_name if provided
        if (data?.display_price !== undefined) {
          this.horseDetails.display_price = data.display_price;
        }
        if (data?.buyer_name) {
          this.horseDetails.buyer_name = data.buyer_name;
        }
      }

      if (!data?.winner?.won_at) {
        if (this.endAuctionDate != data?.auction_item_end_date) {
          this.endAuctionDate = data?.auction_item_end_date;
          this.currentDate = data.current_datetime;
        }

        // Re-evaluate auction type if horse has closed (has status)
        if (this.horseDetails?.status) {
          this.getAuctionType(this.auctionSettings.running, this.auctionSettings.ended);
          if (this.confirmationPopup) {
            this.confirmationPopup.close();
          }
          this.getData(false);
        }
      } else {
        this.auc_type = 'previous';
        if (this.confirmationPopup) {
          this.confirmationPopup.close();
        }

        this.getData(false);
      }

      setTimeout(() => {
        this.notification.showNotification('Auction Update', {
          body: `Highest bid: ${this.amount}`,
          icon: 'assets/images/x-logo.png',
        });
      }, 0);
    }
  }
  subscribeToAutomaticBiddingChannel() {
    this.pusherService.subscribeToPrivateChannel(
      'private-user.{user_id}',
      'automatic-bidding.updated',
      true,
      'Automatic Bidding Updated',
      (data: any) => {
        if (data.auction_item_id === this.horseId) {
          const isAutoBid = data?.is_active;
          this.isAutoBid.next(isAutoBid);
          this.getData(false);
        }
      }
    );
  }
  subscribeToOfferUpdatesChannel() {
    this.pusherService.subscribeToPrivateChannel(
      'private-user.{user_id}',
      'item_offer.updated',
      true,
      'Offer Updated',
      (data: any) => {
        if (data.auction_item_id === this.horseId) {
          this.getData(false);
        }
      }
    );
  }

  subscribeToNotesDeletedChannel() {
    this.pusherService.subscribeToPrivateChannel(
      'private-user.{user_id}',
      'horse_note.deleted',
      true,
      'Horse Notes Deleted',
      (data: any) => {
        if (data.auction_item_id === this.horseId) {
          this.getData(false);
        }
      }
    );
  }

  // New method to handle immediate notes updates
  onNotesUpdated(updatedNotes: any): void {
    // Update the horse details immediately without waiting for pusher or API call
    if (this.horseDetails) {
      this.horseDetails.buyer_horse_note = {
        ...this.horseDetails.buyer_horse_note,
        ...updatedNotes,
      };
    }
  }

  subscribeToAuctionChannel() {
    const subscription = this.pusherSubscriptionService
      .getAuctionUpdates$()
      .subscribe((data) => {
        if (data.auction_id === this.auctionId) {
          this.getData(false);
        }
      });

    this.subscriptions.push(subscription);
  }
  subscribeToBuyerApplicationsChannels() {
    this.buyerApplicationsEvents.forEach((channelConfig) => {
      channelConfig.events.forEach(
        (event: {
          eventName: string;
          showNot: boolean;
          pushTitle: string;
          accepted: boolean;
        }) => {
          this.pusherService.subscribeToPrivateChannel(
            'private-user.{user_id}', // Template channel name
            event.eventName,
            event.showNot,
            event.pushTitle,
            (data: {
              auction_ids: any;
              buyer_user_id: number;
              seller_id: number;
            }) => {
              if (data?.auction_ids) {
                if (data?.auction_ids.includes(this.auctionId)) {
                  this.auctionSettings = changeAuctionItemStatus(
                    event.accepted,
                    this.auctionSettings
                  );
                  if (event.accepted && this.auc_type == 'active') {
                    this.getData(false);
                  }
                }
              }
            }
          );
        }
      );
    });
  }

  subscribeToPrivateTermsAndConditionsUpdated() {
    this.pusherSubscriptionService.subscribeToPrivateTermsAndConditionsUpdated(
      (data: any) => {
        if (data?.affected_auctions?.includes(this.auctionId)) {
          this.buyerTerms.seller_terms = data?.terms_and_conditions;
          this.buyerTerms.buyer_accepted = 'not accepted';
        }
      }
    );
  }
  unsubscribeToPrivateUserChannel() {
    this.pusherService.unsubscribeFromPrivateChannel();
  }
  unsubscribeToPublicChannel() {
    this.pusherService.unsubscribeFromPublicChannel();
  }

  openActiveImg(img: any) {
    if (img != '/assets/images/defualt-image.jpg') {
      const activeIn = this.thumbnails.findIndex((el) => el.src == img.src);
      if (activeIn != -1) {
        this.openLightbox(activeIn);
      }
    }
  }
  openLightbox(index: number): void {
    // console.log(this.thumbnails);
    this.dialog.open(ImageLightboxComponent, {
      data: {
        src: this.thumbnails[index]?.src,
        images: this.thumbnails,
        currentIndex: index,
      },
      panelClass: ['custom-dialog-container', 'buyer-theme'],
      maxWidth: '95vw',
      maxHeight: '95vh',
    });
  }
  sanitizeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  /**
   * Get localized category name based on current language
   */
  getCategoryName(categoryName: any): string {
    if (!categoryName) return 'Unknown Category';
    if (typeof categoryName === 'string') return categoryName;
    const currentLang = this.languageService.getCurrentLanguage();
    return (
      categoryName[currentLang] ||
      categoryName['en'] ||
      categoryName[Object.keys(categoryName)[0]] ||
      'Unknown Category'
    );
  }

  ngOnDestroy(): void {
    // Clean up RxJS subscriptions
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];

    // Clean up event listeners to prevent memory leaks
    if (this.isBrowser) {
      document.removeEventListener('visibilitychange', this.visibilityListener);
      window.removeEventListener('online', this.onlineListener);
    }
  }
}
